<script>
  import { link } from 'svelte-spa-router';
  import Icon from '../components/Icon.svelte';

  let pins = [1,2,3,4];
</script>

<style>
  a {
    color: var(--color);
  }

  content {
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    flex: flex-grow;
    flex-basis: 100%;
    grid-column: 1/3;
    padding: 1rem;
  }


  header {
    display: flex;
    width: 100%;
    flex-direction: row;
  }

  nav {
    flex: 1;
  }

  button {
    padding: 0.5rem;
  }

  profile {
    display: flex;
    flow-direction: row;
  }

  profile figure {
    padding-right: 3rem;
    padding-left: 3rem;
  }

  profile info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  profile info p {
    padding: 0.5rem;
  }

  tabs nav {
    justify-content: center;
    border-top: 1px black solid;
    border-color: var(--color-inactive);
  }

  pins {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
</style>


<content>
  <header>
    <nav>
      <b><Icon name="instagram" color="var(--color-text)" /> Instagram</b>
      <input placeholder="Search">
      <ul>
        <li><button>Log In</button></li>
        <li><a>Sign Up</a></li>
      </ul>
    </nav>
  </header>

  <profile>
    <figure>
      <img alt="Zed's Face" src="https://via.placeholder.com/256x256?text=Zed's Face">
    </figure>

    <info>
      <p>
        <b>zedshaw</b> <button>follow</button>
      </p>

      <p>
        <b>280</b> posts <b>4,695 followers</b> <b>1,778 following</b>
      </p>

      <p><b>Zed A. Shaw</b></p>
      <p>Painter in oil, watercolor, and pastel. I’m doing live streams of little paintings on Twitch:<br>
        <a href="www.twitch.tv/zedashaw">www.twitch.tv/zedashaw</a>
      </p>
    </info>
  </profile>

  <pins>
  {#each pins as pin}
    <figure>
      <img alt="Stock photo" src="https://via.placeholder.com/82x82?text=Story">
    </figure> 
  {/each}
  </pins>
</content>
